import Vue from 'vue';
import { getFlipperFeatures } from 'widget/api/flipperFeatures';

const state = {
  data: {},
  uiFlags: {
    isError: false,
    hasFetched: false,
  },
};

export const getters = {
  getHasFetched: $state => $state.uiFlags.hasFetched,
  getFlags: $state => $state.data,
  isEnabled: $state => flagName => !!$state.data[flagName],
};

export const actions = {
  fetch: async ({ commit }, websiteToken) => {
    try {
      const { data } = await getFlipperFeatures(websiteToken);
      commit('set', data.flipper_features || {});
      commit('setError', false);
      commit('setHasFetched', true);
    } catch (error) {
      commit('setError', true);
      commit('setHasFetched', true);
    }
  },
};

export const mutations = {
  set($state, data) {
    Vue.set($state, 'data', data);
  },
  setError($state, value) {
    Vue.set($state.uiFlags, 'isError', value);
  },
  setHasFetched($state, value) {
    Vue.set($state.uiFlags, 'hasFetched', value);
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
